import * as React from 'react';
import { Context as ReactContext, useContext, useState } from 'react';
import * as Styled from '../../../Common/Styles/portalManagement.styled';
import { SubscriberRecord } from '../../../Common/ConsumerModels/SubscriberRecord';
import { TextField, TooltipHost, Icon, mergeStyles, PrimaryButton, ICommandBarItemProps, CommandBar, Button, CommandButton, CommandBarButton } from '@fluentui/react'
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';

type TeamsLinkProps = {
  subscriberRecord: SubscriberRecord;
  isAdmin: boolean;
};

export function TeamsLink(props: TeamsLinkProps): React.ReactElement {
    const { subscriberRecord, isAdmin } = props;
    const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);
    const [teamsLink, setTeamsLink] = useState<string>(subscriberRecord.teamsChannelUrl);

    const buttonStyle = {
        root: {
            backgroundColor: '#F2F9FF'
        }
    };

    const handleTeamsLinkChange = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        setTeamsLink(newValue);
    };

    const saveNewLink = async () => {
        return httpClient.post(`${__API_BASE_URL__}/subscriber/upsertSubscriber`, {
            resource: __CLIENT_ID__,
            headers: {
                'Content-Type': 'application/json',
                'X-Content-Type-Options': 'nosniff',
            },
            data: { ...subscriberRecord, teamsChannelUrl: teamsLink }
        });
    };

    return (
        <>
            {
                isAdmin ? (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row'
                    }}>
                        <TextField
                            size={10}
                            onChange={handleTeamsLinkChange}
                            value={teamsLink}
                            label='Link to Support Channel'
                            styles={{
                               subComponentStyles: {
                                label: {
                                 root: { display: 'none' }
                                }
                               }
                            }}
                        >
                        </TextField>
                        &nbsp;
                        <CommandBarButton
                            text='Save'
                            onClick={saveNewLink}
                            iconProps={{ iconName: 'Save' }}
                            styles={ buttonStyle }
                        />
                        <CommandBarButton
                            text='Open Link'
                            iconProps={{ iconName: 'OpenInNewWindow' }}
                            styles={ buttonStyle }
                            onClick={ () => {window.open(teamsLink)} }
                        />
                    </div>
                )
                :
                (
                    <Styled.Value>
                        <a href={teamsLink} target="_blank" rel="noopener noreferrer" aria-label='Open Teams Channel'>Teams Channel&nbsp;
                            <Icon
                            data-testid="Support-Teams-Channel-Link"
                            aria-label="Support Teams Channel Link"
                            iconName="OpenInNewWindow"
                            aria-hidden="true"
                            />
                        </a> 
                    </Styled.Value>

                )
            }
        </>
    )
}